<script setup lang="ts">
import { computed, ref, watch,getCurrentInstance } from 'vue'
const {proxy} = getCurrentInstance();
const router = proxy.$dcRouter
const route = proxy.$dcRoute
console.log(router)
import { ElMessageBox } from 'element-plus'
import { ElMessage } from 'element-plus'
import DynamicFormUtils from 'devcude-common/src/utils/DynamicFormUtils'
import DynamicFormDialog from '../form/DynamicFormDialog.vue'
import type DynamicListModel from 'devcude-common/src/models/dynamic-form/DynamicListModel'
import Pager from 'devcude-common/src/models/dynamic-form/Pager'
import _ from 'lodash'
import DcDynamicComp from '../form/DcDynamicComp.vue'
import EntityDesignDialog from '../biz/EntityDesignDialog.vue'
import { DcUtils } from 'devcude-common/src/utils/DcUtils'

const props = defineProps({
  queryParams: {
    type: Object,
    default: () => ({ conds: '' })
  },
  saveParams: {
    type: Object,
    default: () => ({})
  },
  entity: {
    type: String,
    default: () => ('')
  },
  dataListFlag: {
    type: String,
    default: 'LIST_MAIN'
  },
  dataFormFlagAdd: {
    type: String,
    default: 'FORM_MAIN'
  },
  dataFormFlagEdit: {
    type: String,
    default: 'FORM_MAIN'
  }
})

const emit = defineEmits(['tableSelectionChange', 'currentRowChange'])



let model = ref<DynamicListModel>()
let dataFormFlag = ref(props.dataFormFlagAdd)
let showDialog = ref(false)
let currentId = ref('')
let currentRow = ref({})
const searchConditionForm = ref({})
const pager = ref(new Pager())
const tableItems = ref([])
const selection = ref([])
const status = ref('LOADING')
const initFormData = ref(false)

async function loadConfig() {
  let config = await DynamicFormUtils.getListModel(props.entity, props.dataListFlag)

  if (config) {
    status.value = 'FINISH'
    model.value = config
    handleRestSearch()
  } else {
    status.value = 'ERROR'
  }

}

function handleRestSearch() {
  console.log(model.value)
  if (model.value) {
    //构造查询条件
    model.value.config.searchFields.forEach((item) => {
      searchConditionForm[item['dataEntityFieldFlag']] = item['defaultValue']
    })
    handleLoadData()
  }


}

async function handleLoadData() {

  let s: Array<string> = []

  let query = props.queryParams.conds ? props.queryParams.conds : ''
  //构造查询条件
  model.value?.config.searchFields.forEach((item) => {
    let v = searchConditionForm.value[item['dataEntityFieldFlag']]
    if (v) {
      s.push(item['dataEntityFieldFlag'] + '@' + (item['cond'] ? item['cond'] : 'eq') + '@' + v)
    }
  })

  if (s.length) {
    if (query) {
      query += ',' + s.join(',')
    } else {
      query = s.join(',')
    }
  }


  try {
    let resp = await model.value?.list(Object.assign({}, {
      conds: query,
      $list: model.value.config.flag
    }, pager.value, { onPage: model.value.config.isPaginated == 'Y' }))
    tableItems.value = resp.data.items
    _.assign(pager.value, _.pick(resp.data.pager, _.keys(pager.value)))
  } catch (err) {
    console.log(err)
  }

}

async function handleAdd() {

  const e = await DynamicFormUtils.getFormModel(props.entity, props.dataFormFlag)
  if (e.config.interactMode == 'PAGE') {
    router.push({
      path: e.config.routeUrl,
      query: {
        ...route.value.query
      }
    })
    return
  }
  initFormData.value = false
  dataFormFlag.value = props.dataFormFlagAdd
  showDialog.value = true
  currentId.value = ''

}

async function handleEdit(id) {

  const e = await DynamicFormUtils.getFormModel(props.entity, props.dataFormFlag)
  if (e.config.interactMode == 'PAGE') {
    router.push({
      path: e.config.routeUrl,
      query: {
        ...route.value.query,
        id: id,
        _action: 'edit'
      }
    })
    return
  }

  initFormData.value = true
  dataFormFlag.value = props.dataFormFlagEdit
  showDialog.value = true
  currentId.value = id
}

async function handleBatchDelete() {

  if (!selection.value.length) {
    ElMessage.warning('您未选中记录')
    return
  }

  ElMessageBox.confirm('你现在正在进行批量删除操作，是否继续?')
    .then(async () => {
      let ids = ''
      selection.value.forEach((item) => {
        if (ids) {
          ids += `,${item['id']}`
        } else {
          ids = item['id']
        }
      })
      let resp = await model.value?.batchDelete({ ids: ids })
      await handleLoadData()

    })
    .catch(() => {
      // catch error
    })
}

async function handleDelete(id) {

  ElMessageBox.confirm('你现在正在进行删除操作，是否继续?')
    .then(async () => {
      await model.value?.cfg({ showTips: true }).delete({ id })
      await handleLoadData()
    })
    .catch(() => {
      // catch error
    })

}

async function handleSelectionChange(e: any) {
  selection.value = e
  emit('tableSelectionChange', e)
}

async function handleTableOpClick(btn, row) {

  if (btn.clickType == 'ROUTE') {

    let strs: Array<string> = []
    let params = []
    if (typeof btn.params === 'string') {
      params = JSON.parse(btn.params)
    }
    params.forEach((e) => {
      let pA = e.split('@')
      let targetParamName = e
      let srcParamName = e
      if (pA.length == 2) {
        srcParamName = pA[0]
        targetParamName = pA[1]
      }
      if (row[srcParamName]) {
        strs.push(`${targetParamName}=${row[srcParamName]}`)
      }
    })
    router.push(btn.url + (strs.length ? ('?' + strs.join('&')) : ''))
  }
}

loadConfig()

function handleDialogConfirm() {
  showDialog.value = false
  handleLoadData()
}

function handleRowClick(row) {
  currentId.value = row.id
  currentRow.value = row
}

let mergeSaveParams = computed(() => {
  return Object.assign({}, { id: currentId.value }, props.saveParams)
})


watch(currentId, () => {
  emit('currentRowChange', currentRow.value)
})

watch(() => props.queryParams, () => {
  handleLoadData()
})

function generateAttrs(row: any, config: any): Attrs {
  return DcUtils.componentAttr({
    row: row,
    saveParams: props.saveParams,
    queryParams: props.queryParams,
    query: route.value.query
  }, config)
}


</script>

<template>
  <div v-if="status == 'ERROR'" class="w-full h-[500px] flex justify-center bg-[#fff] items-center">
    无法加载模型列表:{{ entity }}@{{ dataListFlag }}
  </div>
  <div v-if="status == 'FINISH' " class="relative">
    <div v-if="model" class="w-full h-full">
      <dynamic-form-dialog v-if="showDialog" :save-params="mergeSaveParams" @cancel="showDialog=false" @confirm="handleDialogConfirm" :show="showDialog" :entity="entity" width="auto" :data-form-flag="dataFormFlag" :init-data="initFormData"></dynamic-form-dialog>
      <div v-if="!model.hideBtnGroup" class="mb-[12px] flex justify-between">
        <template v-if="model.config.showLeftBtnGroup == 'Y'">
          <el-button-group>
            <el-button @click="handleAdd()" icon="plus">新增</el-button>
            <el-button @click="handleBatchDelete()" icon="delete">删除</el-button>
          </el-button-group>
        </template>

        <template v-if="model.config.showRightBtnGroup == 'Y'">
          <div class="flex flex-1 flex-row-reverse">
            <el-button-group>
              <el-button>
                <el-icon>
                  <span class="iconfont dc-icon-daochu"></span>
                </el-icon>
              </el-button>
              <el-button>
                <el-icon>
                  <span class="iconfont dc-icon-list-setting"></span>
                </el-icon>
              </el-button>
            </el-button-group>
          </div>
        </template>


      </div>
      <el-divider v-if="model.config.searchFields?.length && !model.hideBtnGroup" class="!mt-0 !mb-[24px]" />
      <template v-if="model.config.searchFields?.length">


        <el-form :inline="true" class="mb-[6px]">

          <template v-for="field in model.config.searchFields" :key="field.dataEntityFieldFlag">
            <el-form-item v-if="field['showStatus'] == 'Y'" :label="field['name']">
              <el-input :placeholder="field['placeholder'] ? field['placeholder'] : field['name']"
                        v-model="searchConditionForm[field['dataEntityFieldFlag']]" clearable />
            </el-form-item>
          </template>

          <el-form-item>
            <el-button @click="handleLoadData" type="primary">查询</el-button>
            <el-button @click="handleRestSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </template>


      <el-table :highlight-current-row="!!currentId" @row-click="handleRowClick"
                :row-style="{cursor:'pointer'}" :current-row-key="currentId" :data="tableItems"
                @selectionChange="handleSelectionChange"
                :row-key="(row:any)=>{return row.id}" border>
        <el-table-column type="selection" :reserve-selection="true"></el-table-column>

        <template v-for="item in model.config.fields" :key="item.name">
          <el-table-column v-if="item['showStatus'] == 'Y'" :label="item['name']" :prop="item['dataEntityFieldFlag']">
            <template #default="scope">
              <slot :name="item['dataEntityFieldFlag']" :row="scope.row">
                <template v-if="!item['diyComp']">
                  {{ scope.row[item['dataEntityFieldFlag']] }}
                </template>

                <dc-dynamic-comp v-else v-bind:is="item['diyComp'] as string"
                                 v-model="scope.row[item['dataEntityFieldFlag']]"
                                 v-bind="generateAttrs(scope.row,item)"></dc-dynamic-comp>


              </slot>

            </template>

          </el-table-column>
        </template>
        <el-table-column v-if="model.config.showTableOp == 'Y'" label="操作" align="right">
          <template #default="scope">
            <el-link v-for="(btn,index) in model.config.opBtns" :key="index" :type="btn.type ?? 'default'"
                     @click="handleTableOpClick(btn,scope.row)" :underline="false" class="mr-[12px]">{{ btn.name }}
            </el-link>
            <el-link type="primary" @click="handleEdit(scope.row.id)" :underline="false" class="mr-[12px]">编辑
            </el-link>
            <el-link :underline="false" type="danger" @click="handleDelete(scope.row.id)">删除
            </el-link>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        v-if="model.config.isPaginated == 'Y'"
        size="size"
        @size-change="handleLoadData"
        @change="handleLoadData"
        class="w-full flex justify-center mt-[24px]"
        v-model:current-page="pager.pageIndex"
        v-model:page-size="pager.pageSize"
        :background="true"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pager.itemCount"
      />

    </div>
    <entity-design-dialog v-if="model && model.config && model.config.entityId" :entity-id="model.config.entityId"
                          init-tab="listDesign"></entity-design-dialog>

  </div>


</template>

<style scoped>

</style>